/**
 * MobileMenu - Mobile navigation drawer component
 */
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Menu } from 'lucide-react';
import RegionSelector from '@/components/RegionSelector';

export const MobileMenu = ({
  isOpen,
  onOpenChange,
  menuStructure,
  expandedSection,
  onToggleSection
}) => {
  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetTrigger asChild>
        <button
          id="mobile-menu-btn"
          data-testid="mobile-menu-btn"
          className="p-2 hover:bg-site-bg-dark hover:text-white transition-colors md:hidden"
        >
          <Menu className="w-6 h-6" />
        </button>
      </SheetTrigger>
      <SheetContent side="left" className="w-[300px] bg-site-bg p-0">
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="p-4 border-b border-site-border-strong">
            <Link 
              to="/" 
              className="flex items-center justify-center"
              onClick={() => onOpenChange(false)}
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_4f5c0ea9-425c-4471-ae6d-15b5f34fda60/artifacts/dtqe730w_logo.png"
                alt="The Cool-Girl Cut"
                className="w-full max-w-[260px] h-auto object-contain"
              />
            </Link>
          </div>

          {/* Navigation */}
          <nav className="flex-1 overflow-y-auto py-4">
            {menuStructure.map((item) => (
              <div key={item.key} className="border-b border-site-border">
                {item.subpages ? (
                  <>
                    <div className="flex items-center justify-between px-6 py-3">
                      <Link
                        to={item.href}
                        className="font-body text-base hover:text-site-accent-blue transition-colors"
                        onClick={() => onOpenChange(false)}
                        data-testid={`mobile-nav-${item.key}`}
                      >
                        {item.label}
                      </Link>
                      <button
                        onClick={() => onToggleSection(item.key)}
                        className="p-2 hover:bg-site-bg-dark hover:text-white transition-colors"
                        data-testid={`mobile-expand-${item.key}`}
                      >
                        <ChevronDown 
                          className={`w-4 h-4 transition-transform duration-200 ${
                            expandedSection === item.key ? 'rotate-180' : ''
                          }`} 
                        />
                      </button>
                    </div>
                    {expandedSection === item.key && (
                      <div className="bg-stone-100 px-6 py-2">
                        {item.subpages.map((subpage) => (
                          <Link
                            key={subpage.href}
                            to={subpage.href}
                            className="block py-2 pl-4 font-body text-sm text-site-text-muted hover:text-site-accent-blue transition-colors"
                            onClick={() => onOpenChange(false)}
                            data-testid={`mobile-subnav-${subpage.href.split('/').pop()}`}
                          >
                            {subpage.label}
                          </Link>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <Link
                    to={item.href}
                    className="block px-6 py-3 font-body text-base hover:text-site-accent-blue transition-colors"
                    onClick={() => onOpenChange(false)}
                    data-testid={`mobile-nav-${item.key}`}
                  >
                    {item.label}
                  </Link>
                )}
              </div>
            ))}
          </nav>
          
          {/* Region Selector */}
          <div className="p-6 border-t border-site-border-strong">
            <p className="font-mono text-xs text-site-text-muted mb-2">REGION</p>
            <RegionSelector />
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default MobileMenu;
